import React, {useCallback, useState} from "react";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormCheck, FormControl, FormGroup, FormLabel} from "react-bootstrap";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ALBUM_EMPTY, useAlbums, useAlbumsMutations} from "../../api/albumapi";
import {ListItemButton} from "../ListItemButton";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {ButtonLoading} from "../ButtonLoading";
import {ConfirmToast} from "../ConfirmToast";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {wait} from "@testing-library/user-event/dist/utils";
import {useBusyContext} from "../../contexts/busycontext";

export function AlbumOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {albums} = useAlbums();
    const albumsCopy = albums ? [...albums] : []
    const albumsOrdered = albumsCopy?.sort((a1, a2) => new Date(a2.dateCreated).getTime() - new Date(a1.dateCreated).getTime())
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {albumsOrdered ? albumsOrdered.map(a => <ListItem key={a.id} onOpenChanged={setOpen}
                                                              album={a}
                                                              onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw bestand link"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>

    </Section>
}

function ListItem(props) {
    const {album, onOpenChanged, icon, onFileEditingChanged} = props;

    return <div className={"mt-1 border border-black rounded-2"}>
        <ListItemButton onClick={() => {
            onFileEditingChanged(album);
            onOpenChanged(true);
        }}>
            <Col className={"text-start"}>
                {album ? album.title : "Geen Titel"}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {icon}
            </Col>
        </ListItemButton>
    </div>
}

function FileOptionModalContent(props) {
    const {busy, setIsBusy} = useBusyContext()
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {createAlbum, editAlbum, deleteAlbum} = useAlbumsMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {
        ...fileEditing,
        dateCreated: fileEditing.dateCreated ? fileEditing.dateCreated.substring(0, 10) : new Date().toISOString().substring(0, 10)
    } : {
        ...ALBUM_EMPTY,
        dateCreated: new Date().toISOString().substring(0, 10)
    }, [])
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {tempFileObject, onFileInputChange} = useForm(initialFileObjectInitializer);
    const {tempObject, onChange} = useForm(initialObjectInintializer)

    const {uploadFile} = useFileMutations();


    async function handleCreateSubmit(e) {
        e.preventDefault();

        let result = await createAlbum({...tempObject, dateCreated: tempObject.dateCreated + "T00:00:00"});
        if (result) {
            const fileFrontUpload = await uploadFile(tempFileObject);
            if (fileFrontUpload) {
                result = await editAlbum({
                    ...result,
                    albumFrontFile: {id: fileFrontUpload?.id, url: fileFrontUpload?.url}
                })
            }
            if (result && tempFileObject.files !== "") {
                Promise.all(Array.from(tempFileObject.files).map(async f => await uploadFile({file: f}))).then(async value => {
                    const resultEdit = await editAlbum({
                        ...result, filealbums: value.map(file => {
                            return {id: file.id}
                        })
                    });
                });
            }
        }
        onOpenChanged(false);
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        console.log({...tempObject, dateCreated: tempObject.dateCreated + "T00:00:00"})

        let result = await editAlbum({...tempObject, dateCreated: tempObject.dateCreated + "T00:00:00"});
        console.log(result)
        if (tempFileObject.file != "") {
            const fileFrontUpload = await uploadFile(tempFileObject);
            if (fileFrontUpload) {
                result = await editAlbum({
                    ...tempObject,
                    dateCreated: tempObject.dateCreated + "T00:00:00",
                    albumFrontFile: {id: fileFrontUpload?.id, url: fileFrontUpload?.url}
                })
            }
        }


        if (tempFileObject.files !== []) {
            Promise.all(Array.from(tempFileObject.files).map(async f => await uploadFile({file: f}))).then(async value => {
                console.log({
                    ...result, filealbums: [...fileEditing.filealbums, ...value.map(file => {
                        return {id: file.id}
                    })]

                });
                const resultEdit = await editAlbum({
                    ...result, filealbums: [...fileEditing.filealbums, ...value.map(file => {
                        return {id: file.id}
                    })]

                })

            });
        }

        setFileEditing(undefined);
        onOpenChanged(false)
    }

    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form onSubmit={(event) => {
            fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
        }}>
            <Section title={fileEditing ? "Wijzig album" : "Nieuw album"}>
                <FormGroup>
                    <FormLabel>{fileEditing ? "Wijzig titel" : "Nieuw album titel"}</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                    <FormLabel>{fileEditing ? "Wijzig creatie datum" : "Album creatie datum"}</FormLabel>
                    <FormControl type={'date'} value={tempObject.dateCreated}
                                 onChange={event => onChange(event, "dateCreated")}/>

                </FormGroup>
                <FormGroup className={"mt-2"}>
                    <FormLabel>{fileEditing ? "Wijzig foto voorkant album" : "Nieuw album foto voorkant"}</FormLabel>
                    <FormControl onChange={(e) => onFileInputChange(e, 'file', false)} type={"file"}/>
                </FormGroup>
                <FormGroup className={"mt-2"}>
                    <FormLabel>{fileEditing ? "Voeg nieuwe foto's toe aan album" : "Voeg foto's toe aan album"}</FormLabel>
                    <FormControl onChange={(e) => onFileInputChange(e, 'files', true)} multiple={true} type={"file"}/>
                </FormGroup>
                <Col xs={12} className={'p-1'}>
                    <Section>
                        <Col xs={12}>
                            <FormLabel htmlFor={'reverseSorting'}>Wijzig sorteer richting in album?</FormLabel>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={'ja'}> <FormCheck
                                defaultChecked={tempObject.reverseSorting}
                                id={'reverseSorting'} name={'reverseSorting'}
                                value={'true'} type={'radio'}
                                onChange={e => onChange(e, 'reverseSorting')}/></LabelWithInput>

                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={'nee'}> <FormCheck defaultChecked={!tempObject.reverseSorting}
                                                                      id={'reverseSorting'} name={'reverseSorting'}
                                                                      value={'false'} type={'radio'}
                                                                      onChange={e => onChange(e, 'reverseSorting')}/></LabelWithInput>
                        </Col>
                    </Section>
                </Col>

                {fileEditing ? <Col xs={6}>
                    <ConfirmToast title={"Delete"} message={"Wil je dit album verwijderen?"}
                                  className={"btn-danger mt-3"} executeFunction={async () => {
                        const message = await deleteAlbum(fileEditing);
                        if (message) onOpenChanged(false);
                        setFileEditing(undefined);
                    }}/>
                </Col> : ""}
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={busy} onClick={(e) => {
                        setIsBusy(true);
                        fileEditing ? handleEditSubmit(e) : handleCreateSubmit(e)
                    }}/>
                </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}